import * as ngCore from '@angular/core'

import { Store } from '../store'

/**
 * Modal used to deploy Quiver resources
 */
@ngCore.Component({
  encapsulation: ngCore.ViewEncapsulation.None,
  selector: 'atn-summit-org-chart-graph',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component implements ngCore.AfterViewInit, ngCore.OnDestroy {
  /** @see {@link Store} */
  public readonly store = ngCore.inject(Store)

  /** {@link HTMLElement} which should contain the {@link cytoscape} graph */
  private readonly _containerElementRefSg =
    ngCore.viewChild<ngCore.ElementRef<HTMLElement>>('container')
  /** {@link HTMLElement} which should contain the navigator (minimap) */
  private readonly _navigatorContainerElementRefSg =
    ngCore.viewChild<ngCore.ElementRef<HTMLElement>>('navigatorContainer')
  /** Watches for container size changes so we can re-layout the graph */
  private _resizeObserver?: ResizeObserver

  /**
   * Effect that binds {@link orgChartSg} to {@link _containerElementSg}
   *
   * @see {@link Manager.bind}
   */
  public ngAfterViewInit(): void {
    const container = this._containerElementRefSg()?.nativeElement
    const navigatorContainer =
      this._navigatorContainerElementRefSg()?.nativeElement
    const chartId = this.store.chartIdSg()
    if (container && chartId) {
      this.store.treeEditorFeature.actions.bind
        .from('TreeEditorGraph.ngAfterViewInit')
        .dispatch({
          chartId,
          container: () => container,
          navigatorContainer: navigatorContainer
            ? () => navigatorContainer
            : undefined,
        })
    }

    if (container) {
      this._resizeObserver = new ResizeObserver(() => {
        const currentChartId = this.store.chartIdSg()
        if (currentChartId) {
          this.store.treeEditorFeature.actions.cleanUp
            .from('TreeEditorGraph.ResizeObserver')
            .dispatch({ chartId: currentChartId })
        }
      })
      this._resizeObserver.observe(container)
    }
  }

  public ngOnDestroy(): void {
    this._resizeObserver?.disconnect()
  }
}
